/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GoogleSearchConsoleUrlInspectionRowData } from './GoogleSearchConsoleUrlInspectionRowData';
import {
    GoogleSearchConsoleUrlInspectionRowDataFromJSON,
    GoogleSearchConsoleUrlInspectionRowDataFromJSONTyped,
    GoogleSearchConsoleUrlInspectionRowDataToJSON,
    GoogleSearchConsoleUrlInspectionRowDataToJSONTyped,
} from './GoogleSearchConsoleUrlInspectionRowData';

/**
 * 
 * @export
 * @interface GoogleSearchConsoleUrlInspectionBatchData
 */
export interface GoogleSearchConsoleUrlInspectionBatchData {
    /**
     * 
     * @type {Array<GoogleSearchConsoleUrlInspectionRowData>}
     * @memberof GoogleSearchConsoleUrlInspectionBatchData
     */
    rows?: Array<GoogleSearchConsoleUrlInspectionRowData>;
    /**
     * 
     * @type {Array<string>}
     * @memberof GoogleSearchConsoleUrlInspectionBatchData
     */
    failedUrls?: Array<string>;
}

/**
 * Check if a given object implements the GoogleSearchConsoleUrlInspectionBatchData interface.
 */
export function instanceOfGoogleSearchConsoleUrlInspectionBatchData(value: object): value is GoogleSearchConsoleUrlInspectionBatchData {
    return true;
}

export function GoogleSearchConsoleUrlInspectionBatchDataFromJSON(json: any): GoogleSearchConsoleUrlInspectionBatchData {
    return GoogleSearchConsoleUrlInspectionBatchDataFromJSONTyped(json, false);
}

export function GoogleSearchConsoleUrlInspectionBatchDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoogleSearchConsoleUrlInspectionBatchData {
    if (json == null) {
        return json;
    }
    return {
        
        'rows': json['rows'] == null ? undefined : ((json['rows'] as Array<any>).map(GoogleSearchConsoleUrlInspectionRowDataFromJSON)),
        'failedUrls': json['failedUrls'] == null ? undefined : json['failedUrls'],
    };
}

export function GoogleSearchConsoleUrlInspectionBatchDataToJSON(json: any): GoogleSearchConsoleUrlInspectionBatchData {
    return GoogleSearchConsoleUrlInspectionBatchDataToJSONTyped(json, false);
}

export function GoogleSearchConsoleUrlInspectionBatchDataToJSONTyped(value?: GoogleSearchConsoleUrlInspectionBatchData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'rows': value['rows'] == null ? undefined : ((value['rows'] as Array<any>).map(GoogleSearchConsoleUrlInspectionRowDataToJSON)),
        'failedUrls': value['failedUrls'],
    };
}

